import { createTheme } from '@mui/material';

export const THEME = {
  main: {
    primary: '#101828',
    secondary: '#7DCC95',
    white: '#fff',
    black: '#292929',
    grey: '#DCDCDC',
    red: '#B53535',
    darkGrey: '#525863',
  },
  green: {
    extraLight: '#D9E8DF',
    light: '#7DCC95',
    regular: '#41926E',
    dark: '#033E3E',
    extraDark: '#022c2c',
  },
  grey: {
    extraLight: '#E8E8E8',
    light: '#DCDCDC',
    regular: '#E4E7EC',
    dark: '#808698',
    extraDark: '#525863',
  },
};

export default createTheme({
  // components: {
  //   MuiButton: {
  //     styleOverrides: {
  //       disabled: {
  //         backgroundColor: THEME.main.primary,
  //         opacity: 0.5,
  //         color: THEME.main.white,
  //       },
  //     },
  //   },
  // },
  // palette: {
  //   primary: {
  //     main: THEME.main.primary,
  //     light: THEME.main.secondary,
  //     dark: THEME.green.extraDark,
  //   },
  // },
});
